<template>
    <div style="position: relative">
        <span class="a-fs-14 a-ptb-10 a-c-333 a-fw-700">服务费：</span>
        <el-table ref="electricAddBill" :data="tableData" :span-method='mergeCols' :highlight-current-row="true" :border='true' style="width: 100%">
            <el-table-column prop="projectId" label="电费项目" width="140">
                <template slot-scope="{ row }">
                    <span>{{ row.projectName || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="stationId" label="站点" width="140">
                <template slot-scope="{ row }">
                    <el-tag type="primary" size='mini' v-if="row.status== 1">已转移</el-tag>
                    <span>{{ row.stationName || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="ammeterId" label="电表号" width="140">
                <template slot-scope="{ row }">
                    <span>{{ row.ammeterNo || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="lastRecordTimeId" label="计费起始时间" width="160" >
                <template slot-scope="{ row }">
                    <span v-if="row.lastRecordTimeReadoOnly">{{ row.lastRecordTime || '-' }}</span>
                    <el-date-picker
                        v-else
                        value-format="yyyy-MM-dd"
                        v-model="row.lastRecordTime"
                        @change="lastRecordTimeChange"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                </template>
            </el-table-column>
            <el-table-column prop="recordTimeId" label="计费终止时间" width="160" >
                <template slot-scope="{ row }">
                    <el-date-picker
                        value-format="yyyy-MM-dd"
                        v-model="row.recordTime"
                        @change="recordTimeChange"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                </template>
            </el-table-column>
            <el-table-column prop="recordPowerId" label="本次度数（kwh）" min-width="180" v-if="billFeeWay == 1">
                <template slot-scope="{ row }">
                    <el-input v-model="row.recordPower" maxlength="24" placeholder="请输入" @input='handleInput(row.recordPower,"recordPower",row.recordPowerId,"recordPowerId", row.projectId)'></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="lastRecordPowerId" label="上次度数（kwh）" min-width="130" v-if="billFeeWay == 1">
                <template slot-scope="{ row }">
                    <el-input v-model="row.lastRecordPower" maxlength="24" placeholder="请输入" @input='handleInput(row.lastRecordPower,"lastRecordPower",row.lastRecordPowerId,"lastRecordPowerId", row.projectId)'></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="periodPowerId" label="本期用电度数（kwh）" min-width="180" v-if="billFeeWay == 1">
                <template slot-scope="{ row }">
                    <span>{{ row.periodPower || 0 }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="serviceUnitPriceId" label="单价（/元/kwh）" min-width="140" v-if="billFeeWay == 1">
                <template slot-scope="{ row }">
                    <el-input v-model="row.serviceUnitPrice" maxlength="24" placeholder="请输入" @input='handleInput(row.serviceUnitPrice,"serviceUnitPrice",row.serviceUnitPriceId,"serviceUnitPriceId", row.projectId)'></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="totalProfitId" label="区间收益" min-width="180">
                <template slot-scope="{ row }">
                    <jd-input-price v-model="row.totalProfit" @input='handleInput(row.totalProfit,"totalProfit",row.totalProfitId,"totalProfitId", row.projectId)'></jd-input-price>
                </template>
            </el-table-column>
            <el-table-column prop="needPayAmountId" label="服务费" min-width="180">
                <template slot-scope="{ row }">
                    <jd-input-price v-model="row.needPayAmount" @input='handleInput(row.needPayAmount,"needPayAmount",row.needPayAmountId,"needPayAmountId", row.projectId)'></jd-input-price>
                </template>
            </el-table-column>
        </el-table>
        <div class="scrollBar">
            <scroll-bar :table-ref="$refs.electricAddBill"></scroll-bar>
        </div>
    </div>
</template>

<script>
    import util from '../../../utils/util'
    import scrollBar from '../../components/table/scrollBar.vue'
    export default {
        components: {
            scrollBar
        },
        data () {
            return {
                debounceTimeout: null,
                util: util,
            }
        },
        props: {
            tableData: {
                default: ()=>{
                    return []
                }
            },
            billFeeWay: { //计费方式:1:按电量,2期
                default: ''
            }
        },
        computed: {
            // 获取所有单元格合并数据
            spanArr() {
                if(!this.tableData.length) return []
                let mergeCols = [] // 需要合并的列（字段）
                if(this.billFeeWay == 1) {
                    mergeCols = ['projectId','stationId','ammeterId','lastRecordTimeId','recordTimeId','recordPowerId','lastRecordPowerId','periodPowerId','serviceUnitPriceId','totalProfitId','needPayAmountId'] // 需要合并的列（字段）
                }else if(this.billFeeWay == 2) {
                    mergeCols = ['projectId','stationId','ammeterId','lastRecordTimeId','recordTimeId','totalProfitId','needPayAmountId'] // 需要合并的列（字段）
                }
                return util.getMergeCells(this.tableData, mergeCols, mergeCols)
            },
        },
        methods:{
            handleInput (value, prop, propValue, propId, projectId) {
                clearTimeout(this.debounceTimeout);
                this.debounceTimeout = setTimeout(() => {
                    // 防抖处理后的输入内容
                    this.tableData.map((item,index)=>{
                        if(item[propId] == propValue) {
                            item[prop] = value
                        }
                    })
                    this.$emit('update:tableData', this.tableData)
                }, 100);
            },
            recordTimeChange (val) {
                this.tableData.map(item=>{
                    item.recordTime = val
                })
                this.$emit('update:tableData', this.tableData)
                this.$emit('recordTimeChange',val)
            },
            lastRecordTimeChange (val) {
                this.tableData.map(item=>{
                    item.lastRecordTime = val
                })
                this.$emit('update:tableData', this.tableData)
                this.$emit('lastRecordTimeChange',val)
            },
            // 合并行
            mergeCols ({ row, column, rowIndex, columnIndex }) {
                return this.spanArr[rowIndex][columnIndex]
            },
            groupById(arr,key) {
                const result = {};
                arr.forEach(item => {
                    if (!result[item[key]]) {
                    result[item[key]] = [];
                    }
                    result[item[key]].push(item);
                });
                return result;
            },
            //数组去重
            uniqueArr (arr) {
                try{
                    for(var i=0; i<arr.length; i++){
                        for(var j=i+1; j<arr.length; j++){
                            if(arr[i].stationId==arr[j].stationId){         //第一个等同于第二个，splice方法删除第二个
                                arr.splice(j,1);
                                j--;
                            }
                        }
                    }
                    return arr;
                }catch(err){
                }
            },
            uniqueArrAmmeter (arr) {
                try{
                    for(var i=0; i<arr.length; i++){
                        for(var j=i+1; j<arr.length; j++){
                            if(arr[i].ammeterId==arr[j].ammeterId){         //第一个等同于第二个，splice方法删除第二个
                                arr.splice(j,1);
                                j--;
                            }
                        }
                    }
                    return arr;
                }catch(err){
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.scrollBar{
    width: 100%;
    // left: 200px ;
    // right: 48px ;
    // position: fixed;
    // bottom: 70px;
    background: #fff;
    // z-index: 100;
}
.el-table__body-wrapper::-webkit-scrollbar {
    /*width: 0;宽度为0隐藏*/
    width: 0px !important;
    height: 0px !important;
}
/deep/ .el-table__fixed, /deep/ .el-table__fixed-right{
    height: 100% !important;
}
/deep/ .el-input-group__prepend{
    height: 32px;
    line-height: 32px;
}
/deep/ .el-date-editor.el-input{
    width: 140px !important;
}
.tjBox{
    position: absolute;
    right: 0;
    top: -40px;
}
</style>